import { CreateFromCodeInIframeProps, RehydrateFromSnapshotInIframeProps, CreateInIframeResult } from '.';
import { InitializeConfig } from './Iframe-shared/InitializeConfig';
import { loadComponentInSourcelessIframeInternal } from './Iframe-sourceless/Outside/loadComponentInSourcelessIframeInternal';
import { SourcelessIframeLoadOptions } from './loadComponentInSourcelessIframe';

/**
 * [Experimental]
 * Creates a detached container from code and loads its default component the same way loadComponentInSourcelessIframe does
 */
export function createComponentFromCodeInSourcelessIframe(
  props: CreateFromCodeInIframeProps,
  // Task 4485007 and Task 4883749: When we are ready to bump OWH version, remove the "= {​​}​​" from the parameter below
  options: SourcelessIframeLoadOptions = {}
): CreateInIframeResult {
  return createOrRehydrateHelper(
    props,
    options,
    {
      type: 'CreateFromCode',
      driverType: props.driverType,
      codeDetails: props.codeDetails,
      heroComponentConfiguration: props.heroComponentConfiguration
    },
    Date.now() /* bootstrapperStartTime */
  );
}

/**
 * [Experimental]
 * Rehydrates a detached container from snapshot
 */
export function rehydrateComponentFromSnapshotInSourcelessIframe(
  props: RehydrateFromSnapshotInIframeProps,
  // Task 4485007 and Task 4883749: When we are ready to bump OWH version, remove the "= {​​}​​" from the parameter below
  options: SourcelessIframeLoadOptions = {}
): CreateInIframeResult {
  return createOrRehydrateHelper(
    props,
    options,
    { type: 'RehydrateFromSnapshot', driverType: props.driverType, snapshot: props.snapshot },
    Date.now() /* bootstrapperStartTime */
  );
}

function createOrRehydrateHelper(
  props: RehydrateFromSnapshotInIframeProps | CreateFromCodeInIframeProps,
  options: SourcelessIframeLoadOptions,
  initializeConfig: InitializeConfig,
  bootstrapperStartTime: number
) {
  return loadComponentInSourcelessIframeInternal(
    initializeConfig,
    props.componentDiv,
    props.scope,
    props.config ?? {},
    options,
    { bootstrapperStartTime }
  );
}

// cspell:ignore Rehydrates bootstrapper
